import type { PermissionName } from "./catalog";
import { getPermissionId } from "./lookup";
import type { PermissionCheck, UserPermission } from "./types";

export function hasPermissionInList(
  userPermissions: readonly UserPermission[],
  permission: PermissionName,
): boolean {
  const permissionId = getPermissionId(permission);
  if (permissionId == null) {
    return false;
  }
  return userPermissions.some((entry) => entry.id === permissionId);
}

export function hasAnyPermissionInList(
  userPermissions: readonly UserPermission[],
  permissions: readonly PermissionName[],
): boolean {
  return permissions.some((permission) =>
    hasPermissionInList(userPermissions, permission),
  );
}

export function hasAllPermissionsInList(
  userPermissions: readonly UserPermission[],
  permissions: readonly PermissionName[],
): boolean {
  return permissions.every((permission) =>
    hasPermissionInList(userPermissions, permission),
  );
}

export function evaluateRoutePermissionRule(
  userPermissions: readonly UserPermission[],
  rule: PermissionCheck,
): boolean {
  if ("permission" in rule) {
    return hasPermissionInList(userPermissions, rule.permission);
  }
  if ("anyOf" in rule) {
    return hasAnyPermissionInList(userPermissions, rule.anyOf);
  }
  return hasAllPermissionsInList(userPermissions, rule.allOf);
}

export function evaluatePermissionCheck(
  userPermissions: readonly UserPermission[],
  check: PermissionCheck,
): boolean {
  return evaluateRoutePermissionRule(userPermissions, check);
}
